export function Button({ as:Tag='button', className='', ...props }) {
  return <Tag className={`btn ${className}`} {...props} />;
}
export default Button;
